
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20.69 20.69"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Vrstva_2","data-name":"Vrstva 2"}},[_c('g',{attrs:{"id":"Vrstva_1-2","data-name":"Vrstva 1"}},[_c('path',{attrs:{"d":"M6.21 16.55a2.07 2.07 0 102.07 2.07 2.07 2.07 0 00-2.07-2.07zM0 0v2.07h2.07l3.72 7.86-1.45 2.48a3.82 3.82 0 00-.2 1 2.07 2.07 0 002.07 2.07h12.41v-2.03h-12a.23.23 0 01-.21-.21v-.1l.93-1.76H15a1.89 1.89 0 001.76-1l3.72-6.72a.57.57 0 00.21-.52 1 1 0 00-1-1H4.34L3.41 0zm16.55 16.55a2.07 2.07 0 102.07 2.07 2.07 2.07 0 00-2.07-2.07z","fill":"#fff","id":"shopping-cart"}})])])])
          )
        }
      }
    